import type { RefObject } from 'react';
import type { LottieViewRef } from '../../atoms/lottie-view/LottieView.data';

interface BornAndRaisedRefs {
  circle1Ref: RefObject<HTMLElement | null>;
  circle2Ref: RefObject<HTMLElement | null>;
  circle1LottieRef: RefObject<LottieViewRef | null>;
  circle2LottieRef: RefObject<LottieViewRef | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { circle1Ref, circle2Ref }: BornAndRaisedRefs,
): void {
  if (circle1Ref.current) {
    timeline.fromTo(
      circle1Ref.current,
      { scale: 0 },
      { scale: 0.35, ease: 'Quad.easeInOut', duration: 1.1 },
    );

    timeline.addLabel('afterFirstExpand', '>0.2');

    const circle1Lottie = {
      progress: 0,
    };
    timeline.fromTo(
      circle1Lottie,
      { progress: 0 },
      {
        progress: 1,
        ease: 'none',
        duration: 0.6,
        onUpdate: () => {
          // circle1LottieRef?.current?.setProgress(circle1Lottie.progress);
        },
      },
      'afterFirstExpand+=0.4',
    );
    timeline.to(
      circle1Ref.current,
      { scale: 1, ease: 'Quad.easeIn', duration: 1 },
      'afterFirstExpand',
    );
  }

  if (circle2Ref.current) {
    timeline.addLabel('startExpand', '>-0.5');

    const circle2Lottie = {
      progress: 0,
    };

    timeline.fromTo(
      circle2Lottie,
      { progress: 0 },
      {
        progress: 1,
        ease: 'none',
        duration: 1.9,
        onUpdate: () => {
          // circle2LottieRef?.current?.setProgress(circle2Lottie.progress);
        },
      },
      'startExpand+=0.1',
    );

    timeline.fromTo(
      circle2Ref.current,
      { scale: 0 },
      { scale: 0.23, ease: 'Quad.easeInOut', duration: 1 },
      'startExpand',
    );

    timeline.to(circle2Ref.current, { scale: 1, ease: 'Quad.easeIn', duration: 1 }, '>0.2');
  }
}
